import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, tap } from 'rxjs';

import { ProductUserType } from '@products/interfaces/product-user-type';
import { DialogService } from '@shared/services/dialog.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  constructor(
    private httpClient: HttpClient,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  addProduct(): Observable<ProductUserType | undefined> {
    return this.dialogService
      .openChoice<ProductUserType>({
        title: 'PRODUCTS.USER_TYPES.TITLE',
        content: 'PRODUCTS.USER_TYPES.CONTENT',
        choices: ProductUserType.map((userType) => ({
          title: 'PRODUCTS.USER_TYPES.' + userType,
          value: userType,
        })),
      })
      .pipe(
        tap((userType) => {
          // show secondary-product-sheet notice when "other" B2B user type is selected
          if (userType === 'OTHER') {
            this.dialogService.open({
              type: 'NOTICE',
              title: 'PRODUCTS.OTHER_USER_TYPE_NOTICE.TITLE',
              content: 'PRODUCTS.OTHER_USER_TYPE_NOTICE.CONTENT',
            });
          }
        }),
        tap((userType) => {
          if (userType) {
            this.router.navigate(
              [
                '/selling/sortiment/product-sortiment/products-start/products/edit',
              ],
              {
                queryParams: { userType: userType },
                relativeTo: this.route,
              }
            );
          }
        })
      );
  }
}
